<!-- O título e o recolher da seção são do shell. -->
<div [formGroup]="form">
  <p class="section-apoio">
    Fecha a proposta impressa, abaixo dos totais.
    @if (isBloqueado && !isSomenteLeitura) {
      <mat-icon class="material-symbols-outlined icone-travado"
        matTooltip="A configuração do orçamento não permite alterar a assinatura.">lock</mat-icon>
    }
  </p>

  <div class="row mt-2">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Saudação</mat-label>
        <input matInput formControlName="assinaturaSaudacao" [readonly]="isBloqueado"
          placeholder="Ex.: Atenciosamente,">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Responsável / setor</mat-label>
        <input matInput formControlName="assinaturaResponsavel" [readonly]="isBloqueado"
          placeholder="Ex.: Equipe Comercial">
      </mat-form-field>
    </div>
  </div>
</div>
